import styled from 'styled-components';
import React from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { T as Tab } from './index.styled2.js';
import { T as TabIndicator } from './index.styled3.js';
import { u as useTabs } from './index.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TabsList$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var dataAttributes = useDataAttributes(rest);

  var _useTabs = useTabs(),
      isVertical = _useTabs.isVertical;

  var ariaOrientation = isVertical ? 'vertical' : 'horizontal';
  var classnames = "gz-tabs__list ".concat(className);

  if (isVertical) {
    classnames = "".concat(classnames, " gz-tabs__list--vertical");
  }

  return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({
    ref: ref,
    role: "tablist",
    className: classnames,
    "aria-orientation": ariaOrientation // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes), {}, {
    children: children
  }));
});
TabsList$1.COMPONENT_ID = 'Gearz.Tabs.List';
TabsList$1.displayName = TabsList$1.COMPONENT_ID;
TabsList$1.Tab = Tab;
TabsList$1.Indicator = TabIndicator;
TabsList$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  children: PropTypes.customWithDescription(function (props, propName, componentName) {
    var prop = props[propName];
    var propAsArray = React.Children.toArray(prop);
    var hasInvalidChild = propAsArray.filter(function (each) {
      return ![Tab.COMPONENT_ID, TabIndicator.COMPONENT_ID].includes(each.type.COMPONENT_ID);
    }).length;
    var hasMoreThanOneIndicator = propAsArray.filter(function (each) {
      return each.type.COMPONENT_ID === TabIndicator.COMPONENT_ID;
    }).length > 1;

    if (hasInvalidChild) {
      return new Error("Invalid prop '".concat(propName, "' supplied to '").concat(componentName, "': Only the following children are allowed: ").concat([Tab.displayName, TabIndicator.displayName].join(','), "."));
    }

    if (hasMoreThanOneIndicator) {
      return new Error("Invalid prop '".concat(propName, "' supplied to '").concat(componentName, "': More than one '").concat(TabIndicator.displayName, "' detected."));
    }

    return null;
  }, 'Content of the tabs list.', {
    type: PropTypes.PROP_TYPES_NAMES.ARRAY_OF,
    infoFromPropTypes: PropTypes.oneOfType([PropTypes.instanceOf(Tab), PropTypes.instanceOf(TabIndicator)])
  })
};
TabsList$1.defaultProps = {
  className: '',
  children: null
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var TabsList = styled(TabsList$1).withConfig({
  componentId: "gz-tabs-1679041987883__sc-1mpl1xg-0"
})(["list-style-type:none;margin:0;padding-left:0;position:relative;white-space:nowrap;&.gz-tabs__list--vertical{overflow-y:auto;", "{display:block;}}&:not(.gz-tabs__list--vertical){align-items:flex-start;display:flex;overflow-x:auto;", "{display:block;}}"], Tab, Tab);
TabsList.displayName = TabsList$1.displayName;
TabsList.propTypes = TabsList$1.propTypes;
TabsList.defaultProps = TabsList$1.defaultProps;

export { TabsList as T };
